import { PageTitle } from "components/core/typography/PageTitle";
import { Mix_Content_Tag_Enum_Enum } from "graphql/generated";
import { MIX_CONTENT_TAG_ENUM_KOREAN } from "utils/enum";

import { DesktopLayout } from "./DesktopLayout";
import { MobileTabletLayout } from "./MobileTabletLayout";

interface ResponsiveHomeLayoutProps {
    tags: Mix_Content_Tag_Enum_Enum[] | null;
    isTagPage?: boolean;
}

/**
 * 홈 페이지 반응형 레이아웃 오케스트레이터
 *
 * 브레이크포인트별 레이아웃 분리:
 * - Mobile/Tablet (< 1025px): MobileTabletLayout
 * - Desktop (≥ 1025px): DesktopLayout
 *
 * 각 레이아웃 컴포넌트에서 표시 조건과 스타일을 명확하게 관리
 */
export const ResponsiveHomeLayout = ({ tags, isTagPage = false }: ResponsiveHomeLayoutProps) => {
    // Show tag name only when explicitly on a tag page
    const shouldShowTagTitle = isTagPage && tags && tags.length === 1;
    const tagName =
        shouldShowTagTitle && tags[0]
            ? MIX_CONTENT_TAG_ENUM_KOREAN[tags[0]]
            : null;

    return (
        <div id="index-page-container" className="flex flex-col">
            {shouldShowTagTitle && tagName && (
                <PageTitle className="hidden text-text-placeholder md:block">
                    <span className="text-secondary-main">{tagName}</span>
                </PageTitle>
            )}
            <MobileTabletLayout tags={tags} />
            <DesktopLayout tags={tags} />
        </div>
    );
};
